export default function ComingSoon({ church, template }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="text-[10px] tracking-[0.35em] uppercase text-[#D4AF37] mb-4">Coming Soon</div>
        <h1 className="font-serif-display text-4xl">{template?.name || "Template"}</h1>
        <p className="text-neutral-400 mt-4">This template is in development for Phase 1B. For now, <a href={`/churches/${church?.slug}?template=traditional`} className="text-[#D4AF37] underline">use the Traditional template</a> or switch from your church dashboard.</p>
      </div>
    </div>
  );
}
